import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  UpdateAgent,
  GetAgent,
  AddAgent,
  GetAllBrands,
  GetProvinces,
  GetCityByProvinceId,
} from "../../fetchs";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

var firstProvinceId = "";

class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: "",
      keyHelper: "",
      title: "",
      desc: "",
      img: "",
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
      userId: "",
      brands: [],
      brandId: "",

      province: [],
      provinceId: null,
      cities: [],
      cityId: null,
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };
  renderValue = (value) => {
    return value && value[0];
  };


  componentDidMount() {
    const key = this.props.match.params.key;
    if (key) {
      this.loadAgent(key);
    }

// دریافت همه برند ها
    GetAllBrands()
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ brands: responseJson });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });

    GetProvinces(0, 999)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ province: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleChangeProvince = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getCitiesByProvinceId();
    });
  };

  getCitiesByProvince = () => {
    if(this.state.provinceId != null){
      firstProvinceId = this.state.provinceId;
    }
    GetCityByProvinceId(firstProvinceId)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ cities: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  loadAgent = (key) => {
    this.setState({ loading: true });
    GetAgent(key)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        this.setState({
          brandId: responseJson.brandId,
          provinceId: responseJson.provinceId,
          cityId: responseJson.cityId,
          userID: responseJson.userId,
        });
        
        firstProvinceId = responseJson.provinceId;
        var ff = responseJson.brandId;
        console.log("bbbbbbbbb : " +ff);
        console.log("kkkkkk : " +key );

        this.getCitiesByProvince();
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  handleSave = () => {
    if (
      this.props.match.params.key &&
      !this.props.match.params.key.includes("&")
    ) {
      UpdateAgent({
        userId: this.state.userID,
        id: this.props.match.params.key,
        BrandId: this.state.brandId,
        cityId: this.state.cityId,
        ProvinceID: this.state.provinceId,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای ویرایش شدن نماینده فروش");
          } else if (response.status === 200) {
            toast.success(" نماینده فروش با موفقیت ویرایش شد");
            this.props.history.push("/main/agents");
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      AddAgent(
        this.state.cityId
          ? {
              UserId: this.props.match.params.key.substring(
                0,
                this.props.match.params.key.length - 1
              ),
              BrandId: this.state.brandId,
              cityId: this.state.cityId,
              ProvinceID: this.state.provinceId,
            }
          : {
              UserId: this.props.match.params.key.substring(
                0,
                this.props.match.params.key.length - 1
              ),
              BrandId: this.state.brandId,
              ProvinceID: this.state.provinceId,
            }
      )
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای اضافه شدن نماینده فروش");
          } else if (response.status === 200) {
            toast.success(" نماینده فروش با موفقیت اضافه شد");
            this.props.history.push("/main/agents");
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "key":
        this.setState({ key: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ keyHelper: "لطفا کلید را وارد کنید" });
        } else {
          this.setState({ keyHelper: "" });
        }
        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.key &&
            !this.props.match.params.key.includes("&") ? (
              <Typography component="h1" variant="h4" align="center">
                ویرایش نماینده فروش
              </Typography>
            ) : (
              <Typography component="h1" variant="h4" align="center">
                افزودن نماینده فروش جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="brandId"
                      name="brandId"
                      select
                      label="برند"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.brandId}
                      onChange={this.handleChange("brandId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.brands.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      InputLabelProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="provinceId"
                      name="provinceId"
                      select
                      label="استان"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.provinceId}
                      onChange={this.handleChangeProvince("provinceId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.province &&
                        this.state.province.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="cityId"
                      select
                      label="شهر"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.cityId}
                      onChange={this.handleChange("cityId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.cities.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      // disabled={
                      //   this.state.loading ||
                      //   this.state.keyHelper.length !== 0 ||
                      //   this.state.key.length === 0
                      // }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

Setting.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Setting));
